import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_DxSelectBox = _resolveComponent("DxSelectBox");
    const _component_g_field_block = _resolveComponent("g-field-block");
    return (_openBlock(), _createBlock(_component_g_field_block, _mergeProps(_ctx.$attrs, {
        name: _ctx.dataMember,
        "error-message": _ctx.errorMessage,
        label: _ctx.label
    }), {
        "g-field-input": _withCtx(({ identification, error, disabled, size, setFocusClass, removeFocusClass, hasSuffix, hasPrefix }) => [
            _createVNode(_component_DxSelectBox, _mergeProps({
                id: identification,
                name: identification,
                "read-only": _ctx.readOnly,
                placeholder: _ctx.placeholder,
                validationStatus: _ctx.validationState,
                "show-clear-button": _ctx.showClearButton,
                dataSource: _ctx.itemSource,
                "value-expr": _ctx.valueExpr,
                "display-expr": _ctx.displayExpr,
                "item-template": _ctx.itemTemplate,
                "search-enabled": _ctx.searchEnabled,
                modelValue: _ctx.internalValue,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.internalValue) = $event))
            }, _ctx._options, {
                onEnterKey: _ctx.onEnterKey,
                onFocusOut: _ctx.onFocusOut
            }), {
                custom: _withCtx(({ data: itemData }) => [
                    _createElementVNode("div", null, [
                        _renderSlot(_ctx.$slots, "default", { data: itemData })
                    ])
                ]),
                _: 3
            }, 16, ["id", "name", "read-only", "placeholder", "validationStatus", "show-clear-button", "dataSource", "value-expr", "display-expr", "item-template", "search-enabled", "modelValue", "onEnterKey", "onFocusOut"])
        ]),
        _: 3
    }, 16, ["name", "error-message", "label"]));
}
